// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum RefundPaymentType {
  DomesticTransfer = "DOMESTIC_TRANSFER",
  ForeignTransfer = "FOREIGN_TRANSFER",
  SepaTransfer = "SEPA_TRANSFER",
  PayGate = "PAY_GATE",
}
export default RefundPaymentType;
